export const STREAM_ERROR_PREFIX = 'STREAM_ERROR:'

export const StreamErrorCode = {
    GATEWAY_CONFIG: 'GATEWAY_CONFIG',
} as const

export type StreamErrorCode =
    (typeof StreamErrorCode)[keyof typeof StreamErrorCode]

export interface StreamErrorPayload {
    reason: string
    model?: string
    [key: string]: unknown
}

export function formatStreamError(
    code: string,
    payload: StreamErrorPayload,
): string {
    return `${STREAM_ERROR_PREFIX}${code}:${JSON.stringify(payload)}`
}

export function parseStreamError(
    message: string | undefined,
): { code: string; payload: StreamErrorPayload } | undefined {
    if (!message?.startsWith(STREAM_ERROR_PREFIX)) {
        return undefined
    }
    const afterPrefix = message.slice(STREAM_ERROR_PREFIX.length)
    const colonIndex = afterPrefix.indexOf(':')
    if (colonIndex === -1) {
        return undefined
    }
    const code = afterPrefix.slice(0, colonIndex)
    try {
        const payload = JSON.parse(
            afterPrefix.slice(colonIndex + 1),
        ) as StreamErrorPayload
        return { code, payload }
    } catch {
        return undefined
    }
}

export function matchesStreamErrorCode(
    message: string | undefined,
    code: string,
): boolean {
    return message?.startsWith(`${STREAM_ERROR_PREFIX}${code}:`) ?? false
}
